import DownloadIcon from '@mui/icons-material/Download';
import {
  Button,
  CircularProgress,
  Fade,
  Menu,
  MenuItem,
  Snackbar,
  IconButton,
  SnackbarContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import * as React from 'react';
import { useMutateReportPdfMutation } from '../../../gql/generated/queries';
import useReportId from "../../../utils/report/useReportId";

/**
 * Query the download links for the report and display them in a menu
 * TODO: Rehab project ID
 * TODO: display the right data
 */
const DownloadReportsButton = () => {
  const reportId = useReportId();
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const [generateReportPDF, { isLoading: isLoadingPdf }] = useMutateReportPdfMutation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleReport = async () => {
    if (!reportId) return;
    const { data } = await generateReportPDF({ input: { reportId } });
    if (data?.generatePdfReport?.pdfReportActiveStorageBlob.url) {
      window.open(data.generatePdfReport.pdfReportActiveStorageBlob.url, '_blank');
    }
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Fade
        in={true}
        timeout={1000}
        style={{ transitionDelay: '1000ms' }}
      >
        {!downMD ? (
          <Button
            id="download-button"
            aria-controls={open ? 'download-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant="text"
            sx={{ color: 'white' }}
            startIcon={<DownloadIcon htmlColor="white" />}
          >downloads</Button>
        ) : (
          <IconButton
            id="download-button"
            aria-controls={open ? 'download-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{ color: 'white' }}
          >
            <DownloadIcon htmlColor="white" />
          </IconButton>
        )}
      </Fade>
      <Menu
        id="download-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorPosition={{ top: 50, left: 150 }}
        MenuListProps={{
          'aria-labelledby': 'download-button',
        }}
      >
        <MenuItem onClick={handleReport}>
          <Typography variant="body2" fontWeight="bold">
            Inspection Report PDF
          </Typography>
        </MenuItem>
      </Menu>
      <Snackbar
        key="report-pdf-download-snackbar"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isLoadingPdf}
      >
        <SnackbarContent
          message="Downloading report..."
          action={<CircularProgress size={24} color="secondary" />}
        />
      </Snackbar>
    </>
  );
};

export default DownloadReportsButton
